import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = () => ({
    maxWidth: 699,
    margin: 'auto',
});
